import { render, staticRenderFns } from "./TopicTag.vue?vue&type=template&id=5449c7cf&scoped=true"
import script from "./TopicTag.vue?vue&type=script&lang=js"
export * from "./TopicTag.vue?vue&type=script&lang=js"
import style0 from "./TopicTag.vue?vue&type=style&index=0&id=5449c7cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449c7cf",
  null
  
)

export default component.exports